"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = void 0;
var _Input = require("./Input");
// TODO: in v9, move styled() from Input.jsx to here
var StyledInput = _Input.Input;
exports.StyledInput = StyledInput;